import React from 'react'
import { useFragment } from 'react-relay'
import { graphql } from 'relay-runtime'

import { Bubble, BubbleProps } from '../../../../components/Bubble/Bubble'
import { FullAdPreview } from '../FullAdPreview/FullAdPreview'
import { AdBlockListItem_PerformanceSummarizedMetaAd$key } from './__generated__/AdBlockListItem_PerformanceSummarizedMetaAd.graphql'
import { KpiDisplay, getDollarFormat } from '../../../../display'
import { useAdsFilterMenuParams } from '../FilterMenu/useFilterMenuParams'
import { CurrencyType, KPI } from '../TopPerformingAds/__generated__/TopPerformingAdsQuery.graphql'

interface AdBlockListItemProps {
  statBubbleVariant: BubbleProps['variant']
  onView: () => void
  onRefresh: () => void
  fragmentKey: AdBlockListItem_PerformanceSummarizedMetaAd$key
  currencyType: CurrencyType
}

export const AdBlockListItem_MetaAd = graphql`
  fragment AdBlockListItem_PerformanceSummarizedMetaAd on PerformanceSummarizedMetaAd {
    id
    name
    primaryText
    externalId
    brandName
    rate
    amountSpent
    ...FullAdPreview_PerformanceSummarizedMetaAd
  }
`

export const AdBlockListItem = ({
  statBubbleVariant,
  onView,
  onRefresh,
  fragmentKey,
  currencyType,
}: AdBlockListItemProps) => {
  const data = useFragment(AdBlockListItem_MetaAd, fragmentKey)
  const { name, brandName, primaryText, externalId, rate, amountSpent } = data
  const [{ adKpi }] = useAdsFilterMenuParams()
  return (
    <div className="flex flex-none gap-4">
      <FullAdPreview fragmentKey={data} />

      <div className="flex flex-1 flex-col justify-between ">
        <div className="space-y-2">
          <div>
            {adKpi !== 'SPEND' ? (
              <>
                <div className="text-midGray text-xs">Spend</div>
                <Bubble variant={statBubbleVariant} size="lg" className="rounded">
                  {getDollarFormat(currencyType).format(amountSpent || 0)}
                </Bubble>
              </>
            ) : <></>}
          </div>
          <div>
            <div className="text-midGray text-xs">
              {KpiDisplay[adKpi as KPI]}
            </div>
            <Bubble variant={statBubbleVariant} size="lg" className="rounded">
              {rate || 0}
            </Bubble>
          </div>
          <button
            className="text-trueBlue mt-2 block font-medium uppercase"
            onClick={onView}
            type="button"
          >
            View details
          </button>
        </div>

        <div className="flex w-48 flex-none flex-col gap-1">
          <div className="text-darkMedium text-sm font-thin">{brandName}</div>
          <div className="text-darkMedium truncate text-lg">{name}</div>
          <div className="mt-2 line-clamp-5 text-xs font-medium text-black">
            {primaryText}
          </div>
          <div className="text-darkMedium mt-3 text-sm font-thin">
            {externalId}
          </div>
        </div>

        <div />

        {/* <Button
          variant="green"
          onClick={onRefresh}
          type="button"
          className="self-start"
        >
          Refresh Ad
        </Button> */}
      </div>
    </div>
  )
}
